// extracted by mini-css-extract-plugin
module.exports = {"section":"sectionManifesto-module--section--3RgKo","image":"sectionManifesto-module--image--1TgnL"};